import { NS_CONFIGURATION, PROJECT, EDITOR, TEAM } from 'redux/constants';
import { action, createType, SYNC, ASYNC } from 'redux-create-type';

export const {
  INIT,
  INVALIDATE,
  SEARCH,
  SET_INACTIVE,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, TEAM)({
    INIT: ASYNC,
    INVALIDATE: ASYNC,
    SEARCH: SYNC,
    SET_INACTIVE: SYNC,
  });

export const init = {
  begin: ({ projectId }) => action(INIT.BEGIN, { projectId }),
  end: ({ teamList }) => action(INIT.END, { teamList }),
};
export const invalidate = {
  begin: () => action(INVALIDATE.BEGIN),
  end: ({ items }) => action(INVALIDATE.END, { items }),
};
export const search = ({ q }) => action(SEARCH, { q });
export const setInactive = value => action(SET_INACTIVE, { value });



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/team/actions.js